import Container from '@mui/material/Container';
import { paths } from 'src/routes/paths';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useParams } from 'src/routes/hook';
import { useEffect, useState } from 'react';
import axiosInstance, { API_ENDPOINTS } from 'src/utils/axios';
import EmentasForm from '../ementas-form';

export default function EmentaEditView() {
  const settings = useSettingsContext();
  const [current,setCurrent] = useState(null);
  const params = useParams();
  const { id } = params;
  const fetchData = async (idmenu) => {
    try {
      const res = await axiosInstance.get(`${API_ENDPOINTS.menu.list}/${idmenu}`);
      setCurrent(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const refreshData = async () => {
    let res = {};
    try {
       res = await axiosInstance.get(`${API_ENDPOINTS.menu.list}/${id}`);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    return res.data;

  };
  useEffect(() => {
    fetchData(id);
  }, [id]);
  
  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Editar ementa"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Ementas',
            href: paths.dashboard.ementas.list,
          },
          { name: 'Editar' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />
{current === null ? null : <EmentasForm current={current} isEdit refresh={refreshData}/>}
      
    </Container>
  );
}
